/**
 *  
 * @param {*} feature_collection 
 * @returns array of indicator property names
 */
export function getIndicatorKeys(feature_collection){
    let features = feature_collection.features;
    let keys = Object.keys(features[0].properties);
    let indicator_keys = [];

    keys.forEach(key => {
        if(key.startsWith('indicator_')){
            indicator_keys.push(key);
        }
    })

    // Natural sort
    // alpha-numeric sorting using a collator, means that when we sort an array it doesn't do it by string byte value but
    // by numeric value i.e. 0, 5, 9, 10 rather than 0, 10, 5, 9 etc.
    // locale is undefined, so will use the runtimes default locale
    let collator = new Intl.Collator(undefined, {numeric: true, sensitivity: 'base'})
    indicator_keys = indicator_keys.sort(collator.compare)

    return indicator_keys;
}

/**
 * get array of indicator names, helpful for constructing labels etc.
 * @param {*} indicator_keys 
 * @returns array of indicator names
 */
 export function getIndicatorNames(indicator_keys){
    let indicator_names = []
    indicator_keys.forEach(indicator_key => {
        let indicator_name = indicator_key.split('_');
        indicator_name.shift()
        const indicator_unit = indicator_name.pop().toUpperCase();
        if (indicator_unit === 'FALSE') { //Added so indicators without units don't end up with brackets around them 
            indicator_name = indicator_name.join(' ').toUpperCase();
            indicator_names.push(indicator_name)
        } else {
        indicator_name = indicator_name.join(' ').toUpperCase();
        indicator_names.push(`${indicator_name} (${indicator_unit})`); //Adds brackets to units
    }})
    return indicator_names;
}
